// eslint-disable-next-line no-restricted-imports
import { Switch as NativeSwitch, SwitchProps } from 'react-native-elements';
import colors, { appTheme } from '@/config/colors';
import { Platform } from 'react-native';

export function Switch(props: SwitchProps) {
  return (
    <NativeSwitch
      trackColor={{
        false: colors.twGrey,
        true: Platform.OS != 'ios' ? colors.primaryBrighter : appTheme.primary,
      }}
      thumbColor={
        props.value && Platform.OS != 'ios' ? colors.green : colors.white
      }
      color={props.value && Platform.OS != 'ios' ? colors.green : colors.white}
      ios_backgroundColor={colors.twGrey}
      {...props}
    />
  );
}
